// extracted by mini-css-extract-plugin
export var container = "_9v-0";
export var icon = "_9v-1";
export var text = "_9v-2";